const GROUPS = {
  ADMIN: 'UG_001000000001770', // 管理员组
  CONFIGUE: 'UG_001000000002143' // 配置组
}

export { GROUPS }
